import { Box } from '@rsos/base-components';
import styled from '@rsos/theme/styled';

export const HeaderContainer = styled(Box).attrs({
  position: 'relative',
  align: 'center',
  width: '100%',
  backgroundColor: 'background',
  borderRadius: '5px',
  overflowY: 'hidden',
})``;

export const StartChatContainer = styled(Box).attrs({
  height: '100%',
  horizontal: true,
  mt: '8px',
  width: '100%',
  px: '8px',
})``;

export const CollaboratorContainer = styled(Box).attrs({
  border: '1px solid',
  borderColor: 'lightLineDivider',
  borderRadius: '5px',
})`
  flex-grow: 0;
  flex-shrink: 1;
  transition: flex 0.6s ease;
  position: relative;
`;

export const ChatContainer = styled(Box).attrs({
  borderTop: '1px solid',
  borderColor: 'lightLineDivider',
  flex: '1',
})``;

export const ActionsBox = styled(Box).attrs({
  position: 'relative',
  horizontal: true,
  align: 'center',
  flex: '0 0 auto',
})``;

export const RedCircle = styled(Box).attrs({
  backgroundColor: 'lightDanger',
  borderRadius: '10px',
  height: '8px',
  mr: '4px',
  width: '8px',
  inline: true,
})``;
